// API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const apiConfig = {
  baseUrl: API_BASE_URL,
  endpoints: {
    tokenExchange: `${API_BASE_URL}/api/apaleo/token-exchange`,
    tokenRefresh: `${API_BASE_URL}/api/apaleo/token-refresh`,
  },
};

export default apiConfig;
